import type { MonospaceDataSource } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const DataSource = withItemType<MonospaceDataSource>().defineCollection({
	name: 'MonospaceDataSource',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'apiName', 'provider', 'preset'],
	},
});
